import context from '@/context'
import { allowErrorDialog } from '@/utils/fetch'
import getComponentKey from '@/utils/getComponentKey'

export const initialState = {

  fetching: false,
  hasValidKey: false,
  gridComponentKey: getComponentKey()
}

export const actionTypes = {

  fetching: 'systemRsaKeys/fetching',
  fetched: 'systemRsaKeys/fetched'
}

export const actionCreators = {

  hasValidKey: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.cryptoService.hasValidKey(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: { hasValidKey: response } })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  generateSystemRsaKeys: () => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.cryptoService.generateSystemRsaKeys(allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: { hasValidKey: response, gridComponentKey: getComponentKey() } })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return { ...state, fetching: false, ...action.data }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/systemRsaKeys.js